export default __webpack_public_path__ + "static/media/portfolio2.54ccc6da.png";